import { useState, useEffect } from 'react';
import { adminStore, DEFAULT_HOME, type HomeContent } from '../../../store/adminStore';

export default function HomeEditor() {
  const [form, setForm] = useState<HomeContent>({ ...DEFAULT_HOME });
  const [saved, setSaved] = useState(false);

  useEffect(() => {
    setForm(adminStore.getStore().home);
  }, []);

  const handleSave = () => {
    adminStore.updateHome(form);
    setSaved(true);
    setTimeout(() => setSaved(false), 2500);
  };

  const handleReset = () => {
    const def = { ...DEFAULT_HOME };
    setForm(def);
    adminStore.updateHome(def);
    setSaved(true);
    setTimeout(() => setSaved(false), 2500);
  };

  return (
    <div className="max-w-3xl">
      <div className="bg-white rounded-2xl p-6 mb-4">
        <div className="flex items-center gap-3 mb-6">
          <div className="w-10 h-10 flex items-center justify-center bg-orange-50 rounded-xl">
            <i className="ri-home-4-fill text-orange-500 text-xl"></i>
          </div>
          <div>
            <h2 className="font-bold text-gray-800">Nội dung Trang chủ</h2>
            <p className="text-xs text-gray-400">Chỉnh sửa tiêu đề, mô tả và đoạn giới thiệu</p>
          </div>
        </div>

        <div className="space-y-5">
          {/* Hero Title */}
          <div>
            <label className="block text-sm font-semibold text-gray-700 mb-1.5">
              Tiêu đề Hero
              <span className="ml-2 font-normal text-gray-400 text-xs">(dùng \n để xuống dòng)</span>
            </label>
            <textarea
              value={form.heroTitle}
              onChange={(e) => setForm((f) => ({ ...f, heroTitle: e.target.value }))}
              rows={3}
              className="w-full px-4 py-3 rounded-xl border border-gray-200 text-sm bg-gray-50 focus:outline-none focus:border-orange-400 transition-colors resize-none"
            />
            <div className="mt-2 p-3 bg-orange-50/60 rounded-xl">
              <p className="text-xs text-gray-400 mb-1">Xem trước:</p>
              <p className="text-lg font-extrabold text-orange-800 whitespace-pre-line leading-tight">
                {form.heroTitle}
              </p>
            </div>
          </div>

          {/* Hero Description */}
          <div>
            <label className="block text-sm font-semibold text-gray-700 mb-1.5">Mô tả Hero</label>
            <textarea
              value={form.heroDescription}
              onChange={(e) => setForm((f) => ({ ...f, heroDescription: e.target.value }))}
              rows={2}
              className="w-full px-4 py-3 rounded-xl border border-gray-200 text-sm bg-gray-50 focus:outline-none focus:border-orange-400 transition-colors resize-none"
            />
          </div>

          {/* Intro Text */}
          <div>
            <label className="block text-sm font-semibold text-gray-700 mb-1.5">
              Đoạn giới thiệu
              <span className="ml-2 font-normal text-gray-400 text-xs">(hiển thị bên dưới hero)</span>
            </label>
            <textarea
              value={form.introText}
              onChange={(e) =>
                setForm((f) => ({ ...f, introText: e.target.value.slice(0, 600) }))
              }
              rows={5}
              className="w-full px-4 py-3 rounded-xl border border-gray-200 text-sm bg-gray-50 focus:outline-none focus:border-orange-400 transition-colors resize-none"
            />
            <p className="text-xs text-gray-400 mt-1">{form.introText.length}/600</p>
          </div>
        </div>
      </div>

      <div className="flex items-center gap-3">
        <button
          onClick={handleReset}
          className="px-5 py-2.5 border border-gray-200 rounded-xl text-sm text-gray-500 hover:bg-gray-50 transition-colors cursor-pointer whitespace-nowrap"
        >
          Khôi phục mặc định
        </button>
        <button
          onClick={handleSave}
          className="px-6 py-2.5 bg-gradient-to-r from-orange-500 to-yellow-400 text-white font-bold rounded-xl hover:opacity-90 transition-all cursor-pointer whitespace-nowrap"
        >
          {saved ? (
            <span className="flex items-center gap-2">
              <i className="ri-check-line"></i> Đã lưu!
            </span>
          ) : (
            'Lưu thay đổi'
          )}
        </button>
      </div>
    </div>
  );
}
